import { render } from "./Container.vue.js?vue&type=template&id=bb64548a!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Container.vue?vue&type=template&id=bb64548a"
import script from "./Container.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Container.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/elements/layouts/Container.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb64548a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb64548a', __exports__)) {
    api.reload('bb64548a', __exports__)
  }
  
  module.hot.accept("./Container.vue.js?vue&type=template&id=bb64548a!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Container.vue?vue&type=template&id=bb64548a", () => {
    api.rerender('bb64548a', render)
  })

}


export default __exports__